import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticle = articles.find((a) => a.isFeatured && a.id === 1) || articles[0];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={featuredArticle.coverImage}
          alt={featuredArticle.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex items-end">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 pb-12 md:pb-16">
          <div className="flex flex-wrap gap-2 mb-4">
            <Link
              to={`/category/${featuredArticle.category}`}
              onClick={scrollToTop}
              className="px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-md hover:bg-accent-600 transition-colors"
            >
              {featuredArticle.categoryName}
            </Link>
            <span className="px-3 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
              独家爆料
            </span>
          </div>

          <Link to={`/article/${featuredArticle.slug}`} onClick={scrollToTop}>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3 hover:text-primary-200 transition-colors">
              {featuredArticle.title}
            </h1>
          </Link>

          <p className="text-sm md:text-base text-white/70 max-w-2xl line-clamp-2 mb-4">
            {featuredArticle.excerpt}
          </p>

          <div className="flex items-center gap-4 text-xs md:text-sm text-white/50">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {featuredArticle.author}
            </span>
            <span>{featuredArticle.publishDate}</span>
            <span>{featuredArticle.readTime} 分钟阅读</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {(featuredArticle.views / 10000).toFixed(1)}万 阅读
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}